import "@/App.css";
import { ReactLenis } from "lenis/react";
import LandingPage from "@/pages/LandingPage";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App bg-[#1a3aa8] text-white min-h-screen antialiased">
        <LandingPage />
      </div>
    </ReactLenis>
  );
}

export default App;
